import { render, staticRenderFns } from "./accountsPage.vue?vue&type=template&id=3e40541f&scoped=true&"
import script from "./accountsPage.vue?vue&type=script&lang=js&"
export * from "./accountsPage.vue?vue&type=script&lang=js&"
import style0 from "./accountsPage.vue?vue&type=style&index=0&id=3e40541f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40541f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
